import styled from 'styled-components';

export const Container = styled.div`
  .list-tools {
    position: sticky;
    background: ${(props) => props.theme.$bg_gray};
    top: 3.8em;
    z-index: 12;

    @media (max-width: 992px) {
      top: 3em;
    }
  }

  .loading-bidding-list {
    height: calc(100vh - 56px);
  }

  &.result-container {
    transition: all 1s;
  }
`;
